export { default } from "./HorizontalCalloutCardStatic";
